module.exports = __webpack_public_path__ + "static/media/jean-paul-gaultier-scandal-big.ff02d50a.png";